export default {
    init() {
        this.init_dropdown('class-dropdown');
        
        //Run JavaScript when a field is added using conditional logic
        jQuery( document ).on( 'cf.add', function(){
            this.init_dropdown('class-dropdown');
        });
    },

    /**
     * Initialising the dropdown.
     * @param {string} query Class that contains the radio buttons + label
     */
    init_dropdown(query) {
        let dropdowns = document.getElementsByClassName(query);
        if(dropdowns) {
            for(let i = 0; i < dropdowns.length; i++) {
                let dropdown = dropdowns[i];

                //if it does not contain up or down, add down as default
                if(!dropdown.classList.contains('up') && !dropdown.classList.contains('down')) {
                    dropdown.classList.add('down');
                }
                //the main section.
                let label = dropdown.getElementsByTagName('label')[0];
                //the options.
                let options_container = dropdown.getElementsByClassName('.content');
                if(options_container.length > 0) {
                    options_container = options_container;
                } else {
                    options_container = document.createElement('div');
                    options_container.classList.add('content');
                    dropdown.appendChild(options_container);
                    let radios = document.getElementsByClassName('radio');
                    if(radios) {
                        // options_container.appendChildren(radios)

                        //the origional radio length before moving any elements.
                        let radio_length = radios.length;
                        let to_append = "";
                        for(let i = 0; i < radio_length; i++) {
                            let radio = radios[0];
                            let radio_input = radio.querySelector('input[type="radio"]');
                            if(radio_input) {
                                radio_input.tabIndex = -1;
                            }
                            radio.tabIndex = -1;
                            // options_container.appendChild(radio);
                            to_append += radio.outerHTML;
                            radio.remove();
                            // options_container.innerHTML += radio.outerHTML;
                        }

                        options_container.innerHTML = to_append;

                        // for(let i = 0; i < radio_length; i++) {
                        //     let radio = radios[i];
                        //     if(!radio.parentElement.classList.contains('content')) {
                        //         radio.remove();
                        //     }
                        // }

                        // this.wait(50);
                    }
                }
                // let options_container = dropdown.getElementsByTagName('div')[0];
                $(label).off();
                let radios = document.querySelectorAll('.radio');
                label.tabIndex = 0;

                $(label).on('click', function() {
                    options_container.classList.toggle('visible');
                    dropdown.classList.toggle('up');
                    dropdown.classList.toggle('down');
                    let tab_index = (options_container.classList.contains('visible')) ? 0 : -1;

                    radios.forEach(radio => {
                        radio.tabIndex = tab_index
                    })
                })


                $(label).on('keydown', function(e) {
                    if (e.keyCode === 13) {
                        options_container.classList.toggle('visible');
                        dropdown.classList.toggle('up');
                        dropdown.classList.toggle('down');
                        // label.click();
                        let tab_index = (options_container.classList.contains('visible')) ? 0 : -1;
                        radios.forEach(radio => {
                            radio.tabIndex = tab_index
                        })
                    }
                })
                // $(label).on('focusout', function(e) {
                //     options_container.classList.remove('visible');
                //     dropdown.classList.remove('up');
                //     dropdown.classList.add('down');
                // }

                var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
                if(!isIE11) {
                    document.addEventListener('focusin', () => {
                        // console.log('focused: ', document.activeElement)
                        let curr_focus = document.activeElement;
                        if(!curr_focus.classList.contains('radio') && !curr_focus.parentElement.classList.contains('class-dropdown')) {
                            options_container.classList.remove('visible');
                            dropdown.classList.remove('up');
                            dropdown.classList.add('down');

                            //adding a tab index to the radio buttons.
                            radios.forEach(radio => {
                                radio.tabIndex = -1;
                            })
                        }
                    }, true);
                }

                radios.forEach(radio => {
                    radio.addEventListener('keydown', (e) => {
                        let input = radio.querySelector("input[type='radio']");
                        let value = radio.querySelector("label").textContent;
                        if (input && value && e.keyCode === 13) {
                            input.checked = !input.checked;
                            $(input).trigger('change');
                            e.preventDefault();
                            label.innerHTML = value;
                            options_container.classList.remove('visible');
                            dropdown.classList.add('down');
                            dropdown.classList.remove('up');

                            //removing all active elements.
                            options_container.querySelectorAll('input[type="radio"].active').forEach(curr_option => {
                                curr_option.classList.remove('active');
                            })

                            // option.classList.add('active');
                            // label.focus();
                            // document.activeElement = label;
                            radios.forEach(radio => {
                                radio.tabIndex = -1;
                            })
                            
                        } 
                    });

                    radio.addEventListener('click', e => {
                        document.activeElement.blur();
                    })
                })

                setTimeout(() => {
                    //when we click on one of the options
                    let options = options_container.querySelectorAll('input[type="radio"]');
                    if(options) {
                        for(let j = 0; j < options.length; j++) {
                            let option = options[j];
                            $(option).off();
                            $(option).on('change', function() {
                                label.innerHTML = option.parentElement.textContent;
                                options_container.classList.remove('visible');
                                dropdown.classList.add('down');
                                dropdown.classList.remove('up');

                                //removing all active elements.
                                options_container.querySelectorAll('input[type="radio"].active').forEach(curr_option => {
                                    curr_option.classList.remove('active');
                                })

                                option.classList.add('active');
                            });
                        }
                    }
                }, 500);


            }
        }
    },
}